import React, { useContext, useState } from "react";
import ReactModal from "react-modal";
import IOrder from "../../../models/IOrder";
import OwButton from "../../shared/OwButton/OwButton";
import OwLabel from "../../shared/OwLabel/OwLabel";
import OwTranslate from "../../shared/OwTranslate/OwTranslate";
import { QuoteQBOEmailEstimateModal } from "../QuoteQBOEmailEstimateModal/QuoteQBOEmailEstimateModal";
import SupplierContext from "../../../contexts/SupplierContext";
import UiContext from "../../../contexts/UiContext";

type Props = {
    order: IOrder;
    createEstimateFn: () => void;
    deleteEstimateFn: () => void;
    viewEstimatePDFFn: () => void;
    getEstimateDataFromQboFn: () => void;
    /** Opens the staff lookup of which QBO invoice the estimate became. */
    findLinkedInvoicesFn?: () => void;
    emailEstimateFn: (emailAddress?: string) => void;
    active: boolean;
};

export const QuoteCreateQBOEstimate: React.FC<Props> = (props) => {
    const supplierModel = useContext(SupplierContext);
    const uiContext = useContext(UiContext);

    const [modalIsOpen, setModalIsOpen] = useState<boolean>(false);
    const [modalStyle, setModalStyle] = useState<any>();
    const [modalComponent, setModalComponent] = useState<any>();

    const emailEstimateFn = () => {
        if (props.order.Vendor) {
            const component = (
                <QuoteQBOEmailEstimateModal closeModalFn={closeModalFn} commitFn={acceptModalFn} vendor={props.order.Vendor} />
            );

            setModalComponent(component);
            setModalIsOpen(true);
        }
    };

    const closeModalFn = () => {
        setModalIsOpen(false);
        setModalComponent(null);
    };

    const acceptModalFn = (emailAddress?: string) => {
        props.emailEstimateFn(emailAddress);
        setModalIsOpen(false);
        setModalComponent(null);
    };

    const createEstimateTitle = supplierModel.Supplier_Integration.qbo_quote_for_est_name ? "create_quote" : "create_estimate";
    const viewEstimatePdfTitle = supplierModel.Supplier_Integration.qbo_quote_for_est_name ? "view_quote_pdf" : "view_estimate_pdf";
    const emailEstimateTitle = supplierModel.Supplier_Integration.qbo_quote_for_est_name ? "email_quote" : "email_estimate";
    const deleteEstimateTitle = supplierModel.Supplier_Integration.qbo_quote_for_est_name ? "delete_quote" : "delete_estimate";
    const estimateSentTitle = supplierModel.Supplier_Integration.qbo_quote_for_est_name ? "quote_sent" : "estimate_sent";

    return (
        <div className={"QuoteCreateQBOEstimate"}>
            <fieldset>
                <legend>
                    <OwTranslate defaultMessage={"quickbooks_online"} id={"quickbooks_online"} />
                </legend>
                {!props.order.qbo_EstimateId ? (
                    <div>
                        <OwButton title={createEstimateTitle} fn={props.createEstimateFn} active={props.active} disableOnActive={true} />
                    </div>
                ) : (
                    <div>
                        <div>
                            <OwButton
                                title={viewEstimatePdfTitle}
                                fn={props.viewEstimatePDFFn}
                                active={props.active}
                                disableOnActive={true}
                            />
                            <OwButton
                                className={"ms-2 btn-primary"}
                                title={emailEstimateTitle}
                                fn={emailEstimateFn}
                                active={props.active}
                                disableOnActive={true}
                            />
                            <OwButton
                                className={"ms-2 btn-danger"}
                                title={deleteEstimateTitle}
                                fn={props.deleteEstimateFn}
                                active={props.active}
                                disableOnActive={true}
                            />
                            {uiContext.showHiddenFeatures ? (
                                <div>
                                    <OwButton
                                        title={"get_estimate_data"}
                                        fn={props.getEstimateDataFromQboFn}
                                        active={props.active}
                                        disableOnActive={true}
                                    />
                                    {props.findLinkedInvoicesFn ? (
                                        <OwButton
                                            className={"ms-2"}
                                            title={"Find linked invoices"}
                                            skipTranslate={true}
                                            fn={props.findLinkedInvoicesFn}
                                            active={props.active}
                                            disableOnActive={true}
                                        />
                                    ) : null}
                                </div>
                            ) : null}
                        </div>
                        <div className={"mt-2 " + (props.order.qbo_EstimateSent ? "text-success" : "text-danger")}>
                            <OwLabel
                                title={estimateSentTitle}
                                leftIconClass={props.order.qbo_EstimateSent ? "fas fa-check" : "fas fa-times"}
                            />
                        </div>
                    </div>
                )}
            </fieldset>

            <ReactModal
                isOpen={modalIsOpen}
                contentLabel="Modal"
                style={modalStyle}
                className={"modalClass"}
                overlayClassName={"overlayClass"}
                ariaHideApp={true}>
                {modalComponent}
            </ReactModal>
        </div>
    );
};
